import { render, staticRenderFns } from "./NewPackageFormat.vue?vue&type=template&id=0713c295&scoped=true&lang=html&"
import script from "./NewPackageFormat.vue?vue&type=script&lang=js&"
export * from "./NewPackageFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713c295",
  null
  
)

export default component.exports